module.exports = __webpack_public_path__ + "static/media/neeko.e2b8de51.png";